import { policyFromLabel } from './commercialTermsCatalog';

/** Clave SAT / CFDI de Por Cobrar: no es el nombre comercial (Starter, Standard…). */
export const isPorCobrarSatSku = (sku) => /^\d{5,}$/.test(String(sku || '').trim());

const CATALOG_NAME_HINTS = [
  [/enterprise plus/i, 'Enterprise Plus'],
  [/enterprise standard/i, 'Enterprise Standard'],
  [/enterprise starter/i, 'Enterprise Starter'],
  [/business plus/i, 'Business Plus'],
  [/business standard/i, 'Business Standard'],
  [/business starter|\bstarter\b/i, 'Business Starter']
];

const blobOf = (lic = {}, custom = {}) =>
  [lic.skuLabel, lic.name, lic.description, lic.descripcion, custom.description, custom.name]
    .filter(Boolean)
    .join(' ');

export const matchCatalogSkuKey = (lic = {}, priceList = {}, custom = {}, unitHint = 0) => {
  const sku = String(lic.sku || '').trim();
  if (sku && priceList[sku]?.prices) return sku;
  const blob = blobOf(lic, custom);
  for (const [re, key] of CATALOG_NAME_HINTS) {
    if (re.test(blob) && priceList[key]?.prices) return key;
  }
  const hint = Number(unitHint) || Number(lic.precioUnitario) || Number(custom.price) || 0;
  if (hint > 0) {
    const near = (a, b) => b > 0 && Math.abs(a - b) / b <= 0.12;
    for (const [key, data] of Object.entries(priceList || {})) {
      const flex = Number(data?.prices?.flex) || 0;
      const commit = Number(data?.prices?.commit) || 0;
      for (const cat of [flex, commit]) {
        if (!cat) continue;
        if (near(hint, cat) || near(hint, cat * 12)) return key;
      }
    }
  }
  return null;
};

/** Flex vs commit según etiqueta de vigencia. Vacío y Preferencial usan precio flex. */
export const catalogPriceTypeFromLabel = (vigenciaLabel) =>
  policyFromLabel(vigenciaLabel).priceType;

/** Si el “unitario” de PC es anual, el otro esquema, o el total de la partida, vuelve al mensual de catálogo. */
export const sanitizeLicenseUnitPrice = (raw, catalogUnit, qty = 1, otherCatalogUnit = 0) => {
  const unit = Number(raw) || 0;
  const catalog = Number(catalogUnit) || 0;
  const other = Number(otherCatalogUnit) || 0;
  const n = Number(qty) || 1;
  if (catalog <= 0) return unit;
  if (unit <= 0) return catalog;
  const near = (a, b) => b > 0 && Math.abs(a - b) / b <= 0.12;
  // Precio sellado del otro esquema (140 commit vs 168 flex): umbral estrecho para no pisar un custom.
  const sameScheme = (a, b) => b > 0 && Math.abs(a - b) / b <= 0.02;
  if (near(unit, catalog)) return catalog;
  if (other > 0 && sameScheme(unit, other) && !near(unit, catalog)) return catalog;
  if (near(unit, catalog * 12)) return catalog;
  if (n > 1 && near(unit, catalog * n)) return catalog;
  if (n > 1 && near(unit, catalog * n * 12)) return catalog;
  if (unit > catalog * 6) return catalog;
  return unit;
};

export const catalogMonthlyUnit = (lic, priceList = {}, custom = {}, priceType = 'commit') => {
  const key = matchCatalogSkuKey(lic, priceList, custom, Number(lic?.precioUnitario) || Number(custom.price) || 0);
  if (!key) return 0;
  const prices = priceList[key]?.prices || {};
  const typed = Number(prices[priceType]) || 0;
  return typed || Number(prices.flex) || Number(prices.commit) || 0;
};

export const displayLicenseLabel = (lic = {}, priceList = {}, custom = {}) => {
  if (lic.skuLabel && !isPorCobrarSatSku(lic.skuLabel)) return lic.skuLabel;
  const key = matchCatalogSkuKey(
    lic,
    priceList,
    custom,
    Number(lic.precioUnitario) || Number(custom.price) || 0
  );
  if (key) return priceList[key]?.name || key;
  if (custom.description) return custom.description;
  if (lic.name) return lic.name;
  if (isPorCobrarSatSku(lic.sku)) return 'Google Workspace';
  return lic.sku || '';
};
